import api from './api';

export const getInvoiceHeaderText = () => {
    return api.get('/settings/invoice-header-text');
};

export const updateInvoiceHeaderText = (value) => {
    return api.put('/settings/invoice-header-text', { value: value ?? '' });
};

export const getBusinessProfile = () => {
    return api.get('/settings/business-profile');
};

export const updateBusinessProfile = (data) => {
    return api.put('/settings/business-profile', data);
};

export const getEmailTemplates = () => {
    return api.get('/settings/email-templates');
};

export const updateEmailTemplate = (key, data) => {
    return api.put(`/settings/email-templates/${key}`, data);
};

export const previewEmailTemplate = (key, data) => {
    return api.post(`/settings/email-templates/${key}/preview`, data);
};

export const getEmailLayout = (key) => {
    return api.get(`/settings/email-templates/${key}/layout`);
};

export const updateEmailLayout = (key, values) => {
    return api.put(`/settings/email-templates/${key}/layout`, { values });
};

export const resetEmailLayoutSection = (key, section) => {
    return api.post(`/settings/email-templates/${key}/layout/reset`, { section });
};

export const sendEmailTemplateTest = (key, data) => {
    return api.post(`/settings/email-templates/${key}/send-test`, data);
};

export const applySharedEmailLayout = (key, values) => {
    return api.post(`/settings/email-templates/${key}/layout/apply-shared`, { values });
};

export const getSmtpSettings = () => {
    return api.get('/settings/smtp');
};

export const updateSmtpSettings = (data) => {
    return api.put('/settings/smtp', data);
};

export const sendSmtpTestEmail = (to) => {
    return api.post('/settings/smtp/test-email', to ? { to } : {});
};

export const getEmailBranding = () => {
    return api.get('/settings/email-branding');
};

export const updateEmailBranding = (data) => {
    return api.put('/settings/email-branding', data);
};

export const getInternalAlerts = () => {
    return api.get('/settings/internal-alerts');
};

export const updateInternalAlerts = (data) => {
    return api.put('/settings/internal-alerts', data);
};

export const sendInternalAlertTest = () => {
    return api.post('/settings/internal-alerts/send-test');
};

export const getTelegramAlerts = () => {
    return api.get('/settings/telegram-alerts');
};

export const updateTelegramAlerts = (data) => {
    return api.put('/settings/telegram-alerts', data);
};

export const getTelegramAlertStock = () => {
    return api.get('/settings/telegram-alerts/stock');
};

export const updateTelegramAlertStockItem = (key, data) => {
    return api.patch(`/settings/telegram-alerts/stock/${encodeURIComponent(key)}`, data);
};

export const sendTelegramAlertTest = () => {
    return api.post('/settings/telegram-alerts/send-test');
};

export const sendTelegramBriefingNow = () => {
    return api.post('/settings/telegram-alerts/send-briefing');
};
